module.exports = __webpack_public_path__ + "img/autospin_btn.37b64ee6.png";